import React from"react"
import{withContent}from"../../utils/hocs"
import CMSContent from"../CMSContent/CMSContent"
const CONTENT_PREM_ERROR="BLINK_ACTIVATION_ERROR"
const BlinkActivationError=(props)=>(<CMSContent pageid={CONTENT_PREM_ERROR}cache={true}language={props.locale}/>)	
export default withContent(BlinkActivationError)
